// extracted by mini-css-extract-plugin
export var avatarContainer = "_95-0";
export var avatarTypingWave = "_95-i";
export var gray = "_95-f";
export var green = "_95-c";
export var icon = "_95-9";
export var image = "_95-1";
export var lg = "_95-6";
export var md = "_95-5";
export var presenceDot = "_95-b";
export var red = "_95-d";
export var sm = "_95-4";
export var status = "_95-a";
export var typingDot = "_95-h";
export var typingPill = "_95-g";
export var xl = "_95-7";
export var xs = "_95-3";
export var xxl = "_95-8";
export var xxs = "_95-2";
export var yellow = "_95-e";